@import '../table/pageWithTable.module.scss';

.departmentCol {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.emailCol {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}
